import type { ReviewListParams, ReviewShowColumns, ReviewStatus, ReviewTab } from '../../types/review'

export const REVIEW_STATUS: Record<'APPROVED' | 'SPAM' | 'PENDING' | 'TRASH', ReviewStatus> = {
  APPROVED: 'approved',
  SPAM: 'spam',
  PENDING: 'hold',
  TRASH: 'trash',
}

// Bulk "set status" + the Status filter dropdown — mirrors legacy
// COMMENTLIST_STATUS_OPTIONS (only Pending/Approved are user-settable there).
export const REVIEW_STATUS_OPTIONS: { value: ReviewStatus; label: string }[] = [
  { value: REVIEW_STATUS.PENDING, label: 'Pending' },
  { value: REVIEW_STATUS.APPROVED, label: 'Approved' },
]

// The Status section select inside the detail dialog — mirrors legacy
// COMMENT_STATUS_OPTIONS (includes Spam, excludes Trash — trash is a
// row/bulk action, not a settable dialog value).
export const REVIEW_DIALOG_STATUS_OPTIONS: { value: ReviewStatus; label: string }[] = [
  { value: REVIEW_STATUS.APPROVED, label: 'Approved' },
  { value: REVIEW_STATUS.SPAM, label: 'Spam' },
  { value: REVIEW_STATUS.PENDING, label: 'Pending' },
]

export const REVIEW_TABS: { id: ReviewTab; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'spam', label: 'Spam' },
  { id: 'trash', label: 'Trash' },
]

export const RATING_OPTIONS = [5, 4, 3, 2, 1]

export const PAGE_SIZE_OPTIONS = [10, 20, 30, 50, 100] as const

export const DEFAULT_PAGE_SIZE = 20

export const DEFAULT_SHOW_COLUMNS: ReviewShowColumns = {
  rating: true,
  status: true,
  product_name: true,
  date_created_gmt: true,
}

export const DEFAULT_REVIEW_LIST_PARAMS: Partial<ReviewListParams> = {
  page: 1,
  limit: DEFAULT_PAGE_SIZE,
  search_parameter: '',
  product_id: '',
  status: '',
  rating: '',
  from: '',
  to: '',
  sort_by: '',
  sort: '',
}
